module.exports = __webpack_public_path__ + "static/solutions_restaurant-80f88bc6b572da2e04d387f78db0c95e.svg";